import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

const CrossIcon = ({ className = "", ...rest }) => {
  return <FontAwesomeIcon icon={faTimes} {...rest} className={className} />;
};

export default CrossIcon;
